import { AlertOctagon } from 'lucide-react';
import { InlineErrorMessage } from '@ooh/ui/components/inline-error-message';

export interface UnmatchedMappingWarningLabels {
  text: string;
}

export interface UnmatchedMappingWarningProps {
  labels: UnmatchedMappingWarningLabels;
  testId?: string;
}

/**
 * Blocking-severity warning for "every row failed to match a unit — the
 * mapping itself is wrong, fix it before approving" (CU-86cbafj4j). Distinct
 * from `preview-phase.tsx`'s inline amber `rematchFailedWarning` block,
 * which means something much less severe ("the rematch call failed, results
 * may be stale" — transient/technical, still worth trying Confirm again).
 * This one uses a red/destructive tone and `AlertOctagon` (vs. the
 * `AlertTriangle` already used for low-confidence badges and per-row
 * unmatched markers) so the two read as visually distinct severities.
 * Renders through the shared `InlineErrorMessage` (`tone`/`icon` slots) so
 * both warnings share one markup source instead of each hand-rolling it
 * (CU-86cbafj4j).
 */
export function UnmatchedMappingWarning({
  labels,
  testId = 'unmatched-mapping-warning',
}: UnmatchedMappingWarningProps) {
  return (
    <InlineErrorMessage tone="destructive" icon={AlertOctagon} testId={testId}>
      {labels.text}
    </InlineErrorMessage>
  );
}
